import { render, staticRenderFns } from "./orderDIFOTPendingCollectionWidget.vue?vue&type=template&id=4c34c53f&scoped=true&"
import script from "./orderDIFOTPendingCollectionWidget.vue?vue&type=script&lang=js&"
export * from "./orderDIFOTPendingCollectionWidget.vue?vue&type=script&lang=js&"
import style0 from "./orderDIFOTPendingCollectionWidget.vue?vue&type=style&index=0&id=4c34c53f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c34c53f",
  null
  
)

export default component.exports